<template>
  <div class="h-full">
    <div class="w-full bg-white py-5 px-5 shadow-lg flex flex-col">
      <template v-if="getCurrentApplication">
        <div class="hidden md:flex flex-row justify-between">
          <div class="flex items-center">
            <img src="@/assets/images/main-logo.svg" class="w-10 h-10" />
          </div>
          <div class="flex flex-row mx-auto w-full justify-between items-center max-w-screen-lg">
            <div class="text-center cursor-default">
              <h5>1 Application Submitted</h5>
            </div>
            <div class="text-center">
              <h5
                :class="[
                  'cursor-default',
                  active === 'start' ? 'text-brand-green' : 'text-brand-black'
                ]"
              >
                2 Additional Reports Requested
              </h5>
            </div>
            <div
              class="text-center"
              v-if="getCurrentApplication.need_applicant_finicity_bank_connection"
            >
              <h5
                :class="[
                  'cursor-default',
                  ['income'].includes(active)
                    ? 'text-brand-green'
                    : ['pay', 'complete'].includes(active)
                    ? 'text-brand-black'
                    : 'text-brand-mid-gray'
                ]"
              >
                3 Income Verification
              </h5>
            </div>
            <div class="text-center">
              <h5
                :class="[
                  'cursor-default',
                  ['pay', 'complete'].includes(active) ? 'text-brand-green' : 'text-brand-mid-gray'
                ]"
              >
                {{ getCurrentApplication.need_applicant_finicity_bank_connection ? "4" : "3" }}
                Confirm Order
              </h5>
            </div>
          </div>
        </div>

        <div class="block md:hidden">
          <div class="flex flex-row justify-between w-full mx-auto">
            <div class="flex flex-row items-center">
              <h2 class="text-3xl">1</h2>
              <h5 class="cursor-default text-xs ml-1">
                Application <br />
                Submitted
              </h5>
            </div>
            <div class="flex flex-row items-center">
              <h2
                :class="[
                  'text-3xl cursor-pointer',
                  active === 'start' ? 'text-brand-green' : 'text-brand-black'
                ]"
              >
                2
              </h2>
              <h5
                class="cursor-default text-xs ml-1"
                :class="[active === 'start' ? 'text-brand-green' : 'text-brand-black']"
              >
                Reports <br />
                Requested
              </h5>
            </div>

            <div
              class="flex flex-row items-center"
              v-if="getCurrentApplication.need_applicant_finicity_bank_connection"
            >
              <h2
                :class="[
                  'text-3xl cursor-pointer',
                  ['income'].includes(active)
                    ? 'text-brand-green'
                    : ['pay', 'complete'].includes(active)
                    ? 'text-brand-black'
                    : 'text-brand-mid-gray'
                ]"
              >
                3
              </h2>
              <h5
                class="cursor-default text-xs ml-1"
                :class="[
                  'cursor-default',
                  ['income'].includes(active)
                    ? 'text-brand-green'
                    : ['pay', 'complete'].includes(active)
                    ? 'text-brand-black'
                    : 'text-brand-mid-gray'
                ]"
              >
                Income <br />
                Verification
              </h5>
            </div>

            <div class="flex flex-row items-center">
              <h2
                :class="[
                  'text-3xl cursor-pointer',
                  ['pay', 'complete'].includes(active) ? 'text-brand-green' : 'text-brand-mid-gray'
                ]"
              >
                {{ getCurrentApplication.need_applicant_finicity_bank_connection ? "4" : "3" }}
              </h2>
              <h5
                class="cursor-default text-xs ml-1"
                :class="[
                  ['pay', 'complete'].includes(active) ? 'text-brand-green' : 'text-brand-mid-gray'
                ]"
              >
                Confirm <br />
                Order
              </h5>
            </div>
          </div>
        </div>
      </template>
    </div>
    <router-view :key="$route.name" />
  </div>
</template>
<script>
import { APPLICATION_GET, AUTH_LOGIN } from "@/store/types"
import { mapGetters } from "vuex"

export default {
  name: "RequestPaymentBase",
  computed: {
    ...mapGetters(["isApplicationLoading", "getCurrentApplication", "isAuthenticated"])
  },
  watch: {
    "$route.name": {
      handler(val) {
        this.active = val.split("request_payment_")[1]
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      active: "start"
    }
  },
  async mounted() {
    if (this.$route.params.shareToken) {
      const shareToken = this.$route.params.shareToken

      try {
        await this.$store.dispatch(AUTH_LOGIN, { shareToken })
      } catch (err) {
        this.$router.push({ name: "403" })
      }
    }

    if (this.$route.params.id && !this.getCurrentApplication) {
      const id = this.$route.params.id
      await this.$store.dispatch(APPLICATION_GET, { id })

      if (
        !this.getCurrentApplication.reports.filter((r) => r.status === "sent_payment_request")
          .length
      ) {
        this.$router.push({ name: "request_payment_complete" })
      } else {
        if (this.$route.name === "request_payment") {
          this.$router.push({
            name: "request_payment_start",
            params: { id: this.$route.params.id }
          })
        }
      }
    }
  }
}
</script>
